import { ArrowRight } from "lucide-react";

export default function SectionCard({ section, onClick }) {
  const image = section.websiteImageUrl || section.imageUrl || section.image || "";

  return (
    <button
      type="button"
      onClick={() => onClick(section)}
      className="group card-soft text-left overflow-hidden lift"
    >
      <div className="aspect-[4/3] overflow-hidden bg-[#FFF3E8]">
        {image ? (
          <img
            src={image}
            alt={section.name}
            loading="lazy"
            className="w-full h-full object-contain object-center transition-opacity duration-500"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center px-4 text-center text-[#F46524] font-semibold">
            {section.name}
          </div>
        )}
      </div>

      <div className="p-5">
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0">
            <h3 className="font-display text-xl text-[#2B2B2B]">
              {section.name}
            </h3>

            {section.description ? (
              <p className="text-sm text-[#5b5a56] mt-2 line-clamp-2">
                {section.description}
              </p>
            ) : null}
          </div>

          <span className="w-9 h-9 rounded-full bg-[#FFEDDD] text-[#F46524] flex items-center justify-center shrink-0 group-hover:bg-[#F46524] group-hover:text-white transition-colors">
            <ArrowRight size={16} />
          </span>
        </div>
      </div>
    </button>
  );
}

